import * as React from 'react';
import { IOutput, IMoveHandler, SetOutputMethodType, ModalHelper } from '../../helpers';
import { PROPERTIES_OUTPUTS_DEBOUNCE_NUMBER } from '../../constants';
import {
    DialogFooter,
    Button, ButtonType,
    TextField,
    Dropdown, IDropdownOption,
    Toggle
} from 'office-ui-fabric-react';

interface IProps {
	outputs: IOutput [];
    addOutput: () => void;
    updateOutputName: (name: string, outputId: string) => void;
    updateOutputLogicalName: (logicalName: string, outputId: string) => void;
    updateOutputType: (type: number, outputId: string) => void;
    updateCanBeSetByQueryString: (canBeSetByQueryString: boolean, outputId: string) => void;
    removeOutput: (outputId: string) => void;
    closeDialog: (save: boolean) => void;
    overIndex: number;
    moveHandler: IMoveHandler;
    types: IDropdownOption[];
    isSharedJourney: boolean;
}

export class OutputsDialog extends React.Component<IProps, any> {

    private inputTimeout:any[];
    private debounceSetOutput = (methodType:SetOutputMethodType, val:any, id:string) => {
     
        let { updateOutputName, updateOutputLogicalName} = this.props;
        if(!this.inputTimeout)
        {
            this.inputTimeout = [];
        }
      
		if(this.inputTimeout[methodType]) {
			clearTimeout(this.inputTimeout[methodType]);
        }
        
		this.inputTimeout[methodType] = setTimeout(() => {
            switch(methodType)
            {
               case SetOutputMethodType.UpdateOutputName:
                    updateOutputName(val, id);
                    break;
               case SetOutputMethodType.UpdateOutputLogicalName:
                    updateOutputLogicalName(val, id)
                    break;
            }
    }, PROPERTIES_OUTPUTS_DEBOUNCE_NUMBER); 
  }
    componentDidMount(){
        ModalHelper.scrollToBottom();
    }

    outputHtml = (output: IOutput, i: number): JSX.Element => {

        let { updateOutputName, updateOutputLogicalName, overIndex, updateOutputType, updateCanBeSetByQueryString, removeOutput, moveHandler, types, isSharedJourney } = this.props;
        let { Id } = output;

        return <div key={ Id }
            className={ "option global-output clearfix " + (overIndex === i ? 'drag-over' : '') }
            onDrop={ (e) => moveHandler.drop(e, i) }
            onDragOver={ (e) => moveHandler.allowDrop(e, i) }>
        
            <Button buttonType={ ButtonType.icon } icon="Move"
                title="Move output"
                className="option-move"
                draggable={ true }
                onDragStart={ (e) => moveHandler.drag(e, i) }
                onDragEnd={ (e) => moveHandler.drop(e, null) }
                tabIndex={-1} />

            <TextField className='output-name' label="Name" value={ output.Name } onChanged={ (val) => this.debounceSetOutput(SetOutputMethodType.UpdateOutputName,val,Id)} required={ true } />

            <TextField className='output-logical-name' label="Logical Name" value={ output.LogicalName } onChanged={ (val) => this.debounceSetOutput(SetOutputMethodType.UpdateOutputLogicalName,val,Id) } required={ true } />

            <div className="output-type">
                <Dropdown options={ types } label={ 'Type' } selectedKey={ output.Type } onChanged={ (val) => updateOutputType(+val.key, Id) }/>
            </div>

            <div className='output-query-string'>
                <Toggle checked={ output.CanBeSetByQueryString } label={ isSharedJourney ? 'Is input?' : 'Can be set by query string?' } onChanged={ (val) => updateCanBeSetByQueryString(val, Id) }/>
            </div>

            <Button buttonType={ ButtonType.icon } icon="Delete" onClick={ () => removeOutput(Id) } title="Delete output"/>
        </div>;
    }

	public render () {

		let { outputs, addOutput, closeDialog, isSharedJourney} = this.props;
        let outputElements: JSX.Element [] = outputs.map(this.outputHtml);

		return <div><br/>
            { outputElements }
            <Button icon="Add" onClick={ () => addOutput() } buttonType={ ButtonType.normal } label="Add output"/>   
            <DialogFooter>
                <Button buttonType={ ButtonType.normal } onClick={ () => closeDialog(false) }>Cancel</Button>
                <Button buttonType={ ButtonType.primary } onClick={ () => closeDialog(true) }>Save</Button>
            </DialogFooter>

        </div>;

	}

}


// WEBPACK FOOTER //
// ./source/ts/components/layout/outputs-dialog.tsx